export default __webpack_public_path__ + "static/media/uncompleted-chk.fe61562f.svg";